import { DcBaseComponent } from '@deleteagency/dc';

export default class SearchFiltersPropertyTypeComponent extends DcBaseComponent {
    static getNamespace() {
        return 'filter-property-type';
    } 

    onInit() {
        this.wrapper = document.querySelector('.js-property-type-wrapper');
        this.trigger = document.querySelector('.js-property-type');

        this.dropdown = document.querySelector('.js-property-type-inner');
        this.propertyText = document.querySelector('.js-property-type-text');
        this.checkbox = document.querySelector('.js-property-type-checkbox');

        this.outer = this.trigger.parentElement.parentElement;

        setTimeout(() => {
            this._getCheckedCheckbox();
        } , 100);


        this.trigger.addEventListener('click', () => {
            if (this.dropdown.classList.contains('active')) {
                this._closeDropdown();
            } else {
                this._openDropdown();
            }
        });

        this.trigger.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                if (this.dropdown.classList.contains('active')) {
                    this._closeDropdown();
                } else {
                    this._openDropdown();
                }
            }
        });

        // keyboard event return to trigger 
        this.dropdown.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this._closeDropdown();
            }
        });

        // if click outside the bounding box of the dropdown, close the dropdown
        document.addEventListener('click', (event) => {
            if ( event.composedPath().includes(this.wrapper) || event.composedPath().includes(this.trigger) || event.composedPath().includes(this.dropdown)) {            
              return;
            }
            this._closeDropdown();          
        });

        // if focus outside of dropdown or trigger, close dropdown
        document.addEventListener('focus', (event) => {
            if ( event.composedPath().includes(this.wrapper) || event.composedPath().includes(this.trigger) || event.composedPath().includes(this.dropdown)) {            
              return;
            }
            this._closeDropdown();          
        });  
                
        this.dropdown.addEventListener('change', (e) => {
            if (e.target.matches('.js-property-type-checkbox')) {
                this._getCheckedCheckbox();
            }
        });

    }


    _openDropdown() {
        this.dropdown.classList.add('active');
        this.trigger.classList.add('active');
        this.outer.classList.add('property-active');

        if (this.dropdown.classList.contains('active')) {                        
            
        }
    }

    _closeDropdown() {
        this.dropdown.classList.remove('active');
        this.trigger.classList.remove('active');
        this.outer.classList.remove('property-active');
    }

    _getCheckedCheckbox() {
        const allProperties = document.querySelector('.all-property-types-checkbox');
        const modalAllProperties = document.querySelector('.all-property-types-checkbox-modal');

        const checkboxes = Array.from(document.querySelectorAll('.property-type-checkbox'));
        const modalCheckboxes = Array.from(document.querySelectorAll('.property-type-checkbox-modal'));

        const nonAllCheckboxes = checkboxes.filter(cb => cb !== ( allProperties));
        const modalNonAllCheckboxes = modalCheckboxes.filter(cb => cb !== (modalAllProperties));

        this._setCheckboxState(allProperties, nonAllCheckboxes, modalAllProperties, modalNonAllCheckboxes);

    }

    _setCheckboxState(allCheckbox, checkboxSet, modalAllCheckbox, modalCheckboxSet) {
        // Initial sync for 'All' checkboxes
        allCheckbox.checked = modalAllCheckbox.checked = checkboxSet.every(cb => !cb.checked);
    
        const updateText = () => {
            if (allCheckbox.checked) {
                this._setText("Any");
            } else {
                const text = checkboxSet.filter(cb => cb.checked)
                    .map(cb => cb.nextElementSibling.textContent)
                    .join(', ');
                const uniqueText = [...new Set(text.split(', '))].join(', ');
                this._setText(uniqueText);
            }           
        };
    
        // Call updateText initially to set the correct text
        updateText();
    
        // Function to synchronize individual checkboxes
        const synchronizeCheckboxes = (source, target) => {
            source.forEach((cb, index) => {
                target[index].checked = cb.checked;
            });
        };
    
        // Function to check if all non-'All' checkboxes are checked
        const areAllNonAllCheckboxesChecked = (checkboxSet) => {
            return checkboxSet.every(cb => cb.checked);
        };
    
        // Function to synchronize 'All' checkboxes
        const synchronizeAllCheckboxes = () => {
            const allChecked = areAllNonAllCheckboxesChecked(checkboxSet) || areAllNonAllCheckboxesChecked(modalCheckboxSet);
            allCheckbox.checked = modalAllCheckbox.checked = allChecked;
    
            if(allChecked) {
                checkboxSet.concat(modalCheckboxSet).forEach(cb => cb.checked = false);
            }
        };
    
        // Event listener for 'All' checkbox changes
        const setupAllCheckboxListeners = () => {
            allCheckbox.addEventListener('change', () => {
                modalAllCheckbox.checked = allCheckbox.checked;
                checkboxSet.concat(modalCheckboxSet).forEach(cb => cb.checked = false);
                updateText();
            });
    
            modalAllCheckbox.addEventListener('change', () => {
                allCheckbox.checked = modalAllCheckbox.checked;
                checkboxSet.concat(modalCheckboxSet).forEach(cb => cb.checked = false);
                updateText();
            });
        };
    
        // Setup listeners for 'All' checkboxes
        setupAllCheckboxListeners();
    
        // Function to update checkboxes and synchronize states
        const updateCheckboxStates = (sourceSet, targetSet, allCheckbox, modalAllCheckbox) => {
            sourceSet.forEach((checkbox) => {
                checkbox.addEventListener('change', () => {
                    synchronizeCheckboxes(sourceSet, targetSet);
                    synchronizeAllCheckboxes(); // Ensure 'All' checkboxes are in sync after any change
                    updateText();
                });
            });
        };
    
        // Synchronize checkboxes initially in case they are pre-checked
        synchronizeCheckboxes(checkboxSet, modalCheckboxSet);
        synchronizeCheckboxes(modalCheckboxSet, checkboxSet);
    
        // Setup event listeners for both sets to keep them in sync
        updateCheckboxStates(checkboxSet, modalCheckboxSet, allCheckbox, modalAllCheckbox);
        updateCheckboxStates(modalCheckboxSet, checkboxSet, modalAllCheckbox, allCheckbox);
    }
    
    

    _setText(text) {        
        this.propertyText.textContent = text;
    }

}
